module.exports = __webpack_public_path__ + "img/3_chemist.cb367131.jpg";